import React from "react";
import { useImmer } from "use-immer";

import { SxProps, TypographyVariant, useTheme } from "@mui/material";

import { IgTooltip } from "./IgTooltip";
import { IgTypography } from "./IgTypography";
import { IgCustomTheme } from "./theme";

interface IgTypographyTooltipProps {
  textWidth?: string;
  textMaxWidth?: string;
  text: string;
  textSx?: SxProps;
  noHover?: boolean;
  variant?: TypographyVariant;
  differentTooltipText?: string;
}
export const IgTypographyTooltip = ({
  text,
  textMaxWidth,
  textSx,
  noHover,
  variant,
  differentTooltipText,
}: IgTypographyTooltipProps) => {
  const [showTooltip, setShowTooltip] = useImmer(false);
  const theme = useTheme();
  return (
    <IgTooltip title={showTooltip ? differentTooltipText || text : ""}>
      <IgTypography
        noWrap={true}
        onMouseOver={(e) => {
          if (e.currentTarget.scrollWidth > e.currentTarget.clientWidth) {
            setShowTooltip((draft) => {
              draft = true;
              return draft;
            });
          }
        }}
        onMouseOut={() => {
          setShowTooltip(false);
        }}
        variant={variant || "h3"}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "block",
          maxWidth: textMaxWidth ?? "100%",
          // width: textWidth ?? "250px",
          "&:hover": {
            cursor: noHover ? "default" : "pointer",
            color: noHover
              ? "inherit"
              : (theme as IgCustomTheme).palette.text.interactive.neutral.hover,
          },
          ...textSx,
        }}
        igStyle={"semibold"}
      >
        {text}
      </IgTypography>
    </IgTooltip>
  );
};
